import React, { useEffect, useState, useRef } from "react";
import { Row, Col } from "react-flexbox-grid";
import {
  Button,
  SelectField,
  TextField,
  Checkbox,
  DialogContainer,
} from "react-md";
import UploadFileIcon from "../../../../../assets/icons/upload-file-icon.png";
import "../styles/createAccountStyles.css";
import "../styles/assignedPlansStyles.css";
import FontIcon from "react-md/lib/FontIcons";
import AccountDashboardUtils from "../services/AccountDashboardUtils";
import EventService from "../../../../../service/event/EventService";
import AssignedPlansUtil from "../services/AssignedPlansUtils";
import PlansUtils from "../services/PlansUtils";
import ExpandableTableAssignedPlans from "../helper/expandableTableAssignedPlans";

export const AssignedPlans = (props) => {
  const [accountData, setAccountData] = useState({});
  const [accountType, setAccountType] = useState(0);
  const [accountIdPrefix, setAccountIdPrefix] = useState("XX");
  const [accountCode, setAccountCode] = useState("");
  const [fullAccountCode, setFullAccountCode] = useState("");
  const [accountStatus, setAccountStatus] = useState("");
  const [accountName, setAccountName] = useState("");
  const [accountMode, setAccountMode] = useState("");
  const [accountId, setAccountId] = useState("");
  const [keyAccountManager, setKeyAccountManager] = useState("");
  const [keyAccManagersObj, setKeyAccManagersObj] = useState([]);
  const [whitelistedDomains, setWhitelistedEmails] = useState([]);
  const [domainTyped, setDomainTyped] = useState("");
  const [logoViewImage, setLogoViewImage] = useState(null);
  const [logoViewPreview, setLogoViewPreview] = useState(null);
  const [mode, setMode] = useState(1);
  const logoViewImageInputRef = useRef(null);
  const [componentMounted, setComponentMounted] = useState(false);

  const [assignedPlansData, setAssignedPlansData] = useState({});
  const [expandableTile, setExpandableTile] = useState(<></>);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(30);
  const [totalCount, setTotalCount] = useState(10);
  const [filterObj, setFilterObj] = useState({});

  const accountDashboardUtils = new AccountDashboardUtils();
  const assignedPlansUtils = new AssignedPlansUtil();
  const plansUtils = new PlansUtils();

  const [isCopyPickerOpen, setIsCopyPickerOpen] = useState(false);
  const [copyPlanIdInput, setCopyPlanIdInput] = useState("");
  const [copyFetchedPlan, setCopyFetchedPlan] = useState(null);
  const [copyFetchedAccount, setCopyFetchedAccount] = useState(null);
  const [copyLookupLoading, setCopyLookupLoading] = useState(false);

  const resetCopyPickerState = () => {
    setCopyPlanIdInput("");
    setCopyFetchedPlan(null);
    setCopyFetchedAccount(null);
    setCopyLookupLoading(false);
  };

  const openCopyPicker = () => {
    resetCopyPickerState();
    setIsCopyPickerOpen(true);
  };

  const closeCopyPicker = () => {
    setIsCopyPickerOpen(false);
    resetCopyPickerState();
  };

  const fetchPlanForCopy = () => {
    const idNum = Number(copyPlanIdInput);
    if (!copyPlanIdInput || Number.isNaN(idNum) || idNum <= 0) {
      EventService.emit("showError", {
        message: "Enter a valid Plan ID",
      });
      return;
    }
    setCopyLookupLoading(true);
    setCopyFetchedPlan(null);
    setCopyFetchedAccount(null);
    plansUtils.getPlanByFilter(
      { pageNum: 1, pageSize: 1, planIds: [idNum] },
      (res) => {
        const plan = res?.plans?.[0];
        if (!plan) {
          setCopyLookupLoading(false);
          EventService.emit("showError", {
            message: `No plan found for ID ${idNum}`,
          });
          return;
        }
        setCopyFetchedPlan(plan);
        if (plan.accountCode) {
          plansUtils.getAccountByCode(
            plan.accountCode,
            (acc) => {
              setCopyFetchedAccount(acc);
              setCopyLookupLoading(false);
            },
            (err) => {
              setCopyLookupLoading(false);
              EventService.emit("showError", {
                message: `Error in fetching account: ${err?.message}`,
              });
            },
          );
        } else {
          setCopyLookupLoading(false);
        }
      },
      (err) => {
        setCopyLookupLoading(false);
        EventService.emit("showError", {
          message: `Error in fetching plan: ${err?.message}`,
        });
      },
    );
  };

  const continueCopyFlow = () => {
    if (!copyFetchedPlan) return;
    const sourcePlan = copyFetchedPlan;
    setIsCopyPickerOpen(false);
    props.setView(3, {
      mode: "copy",
      accountId: props.data.accountId,
      planId: sourcePlan.id,
      sourcePlan,
      sourceAccountName: copyFetchedAccount?.accountName ?? null,
    });
  };

  useEffect(() => {
    getAccount(props.data.accountId);
    setComponentMounted(true);
  }, []);

  useEffect(() => {
    if (componentMounted) {
      getAssignedPlansByFilter(fullAccountCode);
    }
  }, [accountId, pageNum, filterObj]);

  useEffect(() => {
    if (componentMounted) {
      setExpandableTile((prev) => (
        <ExpandableTableAssignedPlans
          {...{
            data: {
              accountId: props.data.accountId,
              assignedPlans: assignedPlansData,
            },
            setView: props?.setView,
            goToPrevPage: navigateToPrevPage,
            goToNextPage: navigateToNextPage,
            fetchAssignedPlansByFilter: fetchAssignedPlansByFilter,
            totalCount: totalCount,
            pageNum: pageNum,
            pageSize: pageSize,
          }}
        />
      ));
    }
  }, [assignedPlansData]);

  const fetchAssignedPlansByFilter = (filterObj) => {
    setPageNum(1);
    setFilterObj(filterObj);
  };

  const getAssignedPlansByFilter = (fullAccountCode) => {
    const onResponse = (res) => {
      // setAssignedServiceProvidersData(res?.assignedServiceProviders);
      setTotalCount((prev) => res?.totalCount ?? 0);
      setAssignedPlansData((prevData) => res?.plans ?? []);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching assigned plans: ${err?.message}`,
      });
    };
    assignedPlansUtils.getAssignedPlansByFilter(
      filterObj?.status
        ? {
            pageNum: pageNum,
            pageSize: pageSize,
            accountCodes: [fullAccountCode?.toString()],
            status: filterObj?.status,
          }
        : {
            pageNum: pageNum,
            pageSize: pageSize,
            accountCodes: [fullAccountCode?.toString()],
          },
      onResponse,
      onError,
    );
  };

  const navigateToNextPage = () => {
    if (pageNum * pageSize < totalCount) {
      setPageNum((prevPageNum) => prevPageNum + 1);
    }
  };
  const navigateToPrevPage = () => {
    if (pageNum > 1) {
      setPageNum((prevPageNum) => prevPageNum - 1);
    }
  };

  const exitPage = () => {
    setAccountData({});
    setPageNum(1);
    setPageSize(2);
    setTotalCount(10);
    setAccountType(0);
    setAccountIdPrefix("XX");
    setAccountCode("");
    setAccountStatus("");
    setAccountName("");
    setAccountMode("");
    setKeyAccountManager("");
    setKeyAccManagersObj([]);
    setWhitelistedEmails([]);
    setDomainTyped("");
    setLogoViewImage(null);
    setLogoViewPreview(null);
    props.setView(0);
  };
  const ACCOUNT_TYPE_OPTIONS = [
    {
      label: "Zyla",
      value: 1,
    },
    {
      label: "Insurance",
      value: 2,
    },
    {
      label: "Pharma",
      value: 3,
    },
    {
      label: "Corporate",
      value: 4,
    },
    {
      label: "Affinity",
      value: 5,
    },
  ];
  let ACCOUNT_STATUS_OPTIONS = [
    {
      label: "Active",
      value: "true",
    },
    {
      label: "Inactive",
      value: "false",
    },
  ];
  let ACCOUNT_MODE_OPTIONS = [
    {
      label: "B2B",
      value: "B2B",
    },
    {
      label: "B2C",
      value: "B2C",
    },
  ];
  const getAccount = (id) => {
    const onResponse = (res) => {
      let accType = res.accountCode.substring(0, 2);
      if (accType === "01") {
        setAccountType(1);
        setAccountIdPrefix("01");
      } else if (accType === "02") {
        setAccountType(2);
        setAccountIdPrefix("02");
      } else if (accType === "03") {
        setAccountType(3);
        setAccountIdPrefix("03");
      } else if (accType === "04") {
        setAccountType(4);
        setAccountIdPrefix("04");
      } else if (accType === "05") {
        setAccountType(5);
        setAccountIdPrefix("05");
      } else {
        setAccountType(0);
      }

      setAccountCode(res.accountCode.substring(2, 6));
      setFullAccountCode(res?.accountCode);
      setAccountId(res.id);
      setAccountStatus(res.status == true ? "true" : "false");
      setAccountName(res.accountName);
      setAccountMode(res.mode);
      setKeyAccountManager(res.managerName);
      // setKeyAccManagersObj([]);
      setWhitelistedEmails(res.whitelistedDomains);
      // setDomainTyped("");
      // setLogoViewImage(null);
      setLogoViewPreview(res.logoImage);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching account: ${err?.message}`,
      });
    };
    accountDashboardUtils.getAccountsById(id, onResponse, onError);
  };

  const renderWhitelistedDomains = () => {
    if (whitelistedDomains.length == 0) {
      return <></>;
    } else {
      return (
        <div className="account-module-domains-container">
          {whitelistedDomains.map((e, index) => {
            return (
              <div className="account-module-domains-box">
                <div className="account-module-font">{`@${e}`}</div>
              </div>
            );
          })}
        </div>
      );
    }
  };

  return (
    <div className="account-module-page-padding">
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="account-module-view">
            <div className="account-module-heading-with-back-button">
              <div
                className="account-module-back-btn"
                onClick={() => {
                  exitPage();
                }}
              >
                <FontIcon style={{ fontSize: "36px", marginTop: "2px" }}>
                  arrow_back
                </FontIcon>
              </div>
              <h1>Assigned plans</h1>
            </div>
          </div>
        </Col>
      </Row>
      <br />
      <br />
      <br />
      <div className="account-module-create-service-container">
        <Row>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="account-module-create-service-field-container">
              <div className="account-module-label">{`Account type`}</div>
              <div>
                <SelectField
                  id="account_type"
                  placeholder="Select account type"
                  className="account-module-select-field"
                  disabled
                  menuItems={ACCOUNT_TYPE_OPTIONS}
                  value={accountType}
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="account-module-create-service-field-container">
              <div className="account-module-label">{`Account ID`} </div>
              <div style={{ display: "flex" }}>
                <div className="account-module-prefix">{accountIdPrefix}</div>
                <TextField
                  id="account_code"
                  value={`${accountCode}`}
                  lineDirection="left"
                  disabled
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="account-module-create-service-field-container">
              <div className="account-module-label">{`Status`}</div>
              <div>
                <SelectField
                  id="account_status"
                  placeholder="Select"
                  className="account-module-select-field"
                  menuItems={ACCOUNT_STATUS_OPTIONS}
                  disabled
                  value={accountStatus}
                />
              </div>
            </div>
          </Col>
        </Row>
        <br />
        <Row>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="account-module-create-service-field-container">
              <div className="account-module-label">{`Account name`} </div>
              <div>
                <TextField
                  id="account_name"
                  value={accountName}
                  lineDirection="left"
                  disabled
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="account-module-create-service-field-container">
              <div className="account-module-label">{`Account mode`}</div>
              <div>
                <SelectField
                  id="account_mode"
                  placeholder="Select account type"
                  className="account-module-select-field"
                  menuItems={ACCOUNT_MODE_OPTIONS}
                  disabled
                  value={accountMode}
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="account-module-create-service-field-container">
              <div className="account-module-label">
                {`Key account manager`}
              </div>
              <div>
                <TextField
                  id="key_account_manager"
                  value={keyAccountManager}
                  lineDirection="left"
                  placeholder="Key account manager"
                  disabled
                />
              </div>
            </div>
          </Col>
        </Row>
        {whitelistedDomains != null && whitelistedDomains.length > 0 && (
          <>
            <br />
            <Row>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="account-module-create-service-field-container">
                  <div className="account-module-label">
                    {`Whitelisted email domains`}
                  </div>
                  <div style={{ height: "10px" }}></div>
                  {renderWhitelistedDomains()}
                </div>
              </Col>
            </Row>
          </>
        )}
      </div>

      <div style={{ height: "60px" }}></div>
      <div className="assigned-plans-table-outer-div">
        <h2 className="">Assigned plans</h2>
        <div className="service-provider-header-inner-div">
          <Button
            id="assigned_plans_add_button"
            raised
            style={{ textTransform: "none" }}
            secondary
            onClick={() => {
              props.setView(3, {
                mode: "create",
                accountId: accountId,
              });
            }}
          >
            Add
          </Button>
          <Button
            id="assigned_plans_copy_and_add_button"
            raised
            secondary
            style={{ textTransform: "none" }}
            onClick={openCopyPicker}
          >
            Copy and Add
          </Button>
        </div>
      </div>
      <div style={{ height: "16px" }}></div>
      {expandableTile}

      <DialogContainer
        id="copy-and-add-picker-dialog"
        visible={isCopyPickerOpen}
        onHide={closeCopyPicker}
        aria-labelledby="copy-and-add-picker-title"
        width={720}
        contentClassName="mp-copy-picker-dialog-content"
        dialogStyle={{ borderRadius: "16px", overflow: "hidden" }}
      >
        <div className="mp-copy-picker-dialog">
          <h2
            id="copy-and-add-picker-title"
            className="mp-copy-picker-heading"
          >
            Choose plan that you want to copy and add
          </h2>

          <div className="mp-copy-picker-form-row">
            <div className="mp-copy-picker-field">
              <div className="account-module-label">
                Plan ID <span className="mp-copy-picker-required">*</span>
              </div>
              <div className="mp-copy-picker-id-input-wrapper">
                <TextField
                  id="copy_picker_plan_id"
                  placeholder="Search"
                  value={copyPlanIdInput}
                  type="number"
                  onChange={(val) => {
                    setCopyPlanIdInput(String(val ?? ""));
                    setCopyFetchedPlan(null);
                    setCopyFetchedAccount(null);
                  }}
                  lineDirection="left"
                />
                <button
                  type="button"
                  className={
                    copyPlanIdInput && !copyLookupLoading
                      ? "mp-copy-picker-arrow mp-copy-picker-arrow-active"
                      : "mp-copy-picker-arrow"
                  }
                  disabled={!copyPlanIdInput || copyLookupLoading}
                  onClick={fetchPlanForCopy}
                  aria-label="Fetch plan details"
                >
                  <FontIcon>arrow_forward</FontIcon>
                </button>
              </div>
            </div>

            <div className="mp-copy-picker-field">
              <div className="account-module-label">Plan name</div>
              <TextField
                id="copy_picker_plan_name"
                value={copyFetchedPlan?.basicDetails?.name ?? "-"}
                disabled
                lineDirection="left"
              />
            </div>

            <div className="mp-copy-picker-field">
              <div className="account-module-label">Account name</div>
              <TextField
                id="copy_picker_account_name"
                value={copyFetchedAccount?.accountName ?? "-"}
                disabled
                lineDirection="left"
              />
            </div>

            <div className="mp-copy-picker-field">
              <div className="account-module-label">Account code</div>
              <TextField
                id="copy_picker_account_code"
                value={copyFetchedPlan?.accountCode ?? "-"}
                disabled
                lineDirection="left"
              />
            </div>
          </div>

          <div className="mp-copy-picker-actions">
            <button
              type="button"
              className="mp-copy-picker-cancel-btn"
              onClick={closeCopyPicker}
            >
              Cancel
            </button>
            <button
              type="button"
              className={
                copyFetchedPlan
                  ? "mp-copy-picker-continue-btn mp-copy-picker-continue-btn-active"
                  : "mp-copy-picker-continue-btn"
              }
              onClick={continueCopyFlow}
              disabled={!copyFetchedPlan}
            >
              Continue
            </button>
          </div>
        </div>
      </DialogContainer>
    </div>
  );
};

export default AssignedPlans;
